import { render } from "./CurtainAction.vue?vue&type=template&id=19ca55c4"
import script from "./CurtainAction.vue?vue&type=script&lang=js"
export * from "./CurtainAction.vue?vue&type=script&lang=js"
script.render = render

export default script